import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const UiContext = createContext({
  contactOpen: false,
  openContact: () => {},
  closeContact: () => {},
  cookiePrefsRequest: 0,
  requestCookiePrefs: () => {},
});

export function UiProvider({ children }) {
  const [contactOpen, setContactOpen] = useState(false);
  const [cookiePrefsRequest, setCookiePrefsRequest] = useState(0);

  const openContact = useCallback(() => setContactOpen(true), []);
  const closeContact = useCallback(() => setContactOpen(false), []);
  const requestCookiePrefs = useCallback(() => setCookiePrefsRequest((n) => n + 1), []);

  const value = useMemo(
    () => ({ contactOpen, openContact, closeContact, cookiePrefsRequest, requestCookiePrefs }),
    [contactOpen, openContact, closeContact, cookiePrefsRequest, requestCookiePrefs]
  );

  return <UiContext.Provider value={value}>{children}</UiContext.Provider>;
}

export function useUi() {
  return useContext(UiContext);
}
